import { ReactNode, ReactElement } from "react";
import { Icon } from "src/components";

const Background = ({
  children,
  noPermission,
}: {
  children: ReactNode;
  noPermission?: boolean;
}): ReactElement => {
  if (noPermission) {
    return (
      <div className="bg-white flex justify-between h-full">
        {children}
        <div className="flex justify-center">
          <Icon name="bg-circles-alt" />
          <div className="absolute bottom-0 mr-auto ml-auto text-center">
            <Icon name="illust-box" />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="flex justify-between h-full"
        style={{
          background: "linear-gradient(116.71deg, #88e7fa 0%, #fec7f8 100%)",
        }}
      >
        {children}
        <div className="flex justify-center">
          <Icon name="bg-circles" />
        </div>
      </div>
    );
  }
};

export default Background;
